import React from 'react';
import './OurVision.css';

function OurVision() {
  return (
    <section id="our-vision" className="our-vision-section">
      <div className="container">
        <h2 className="section-title">Our Vision</h2>
        <p className="vision-statement">
          To create a healthier world by building scalable, ethical, and impactful solutions
          that enhance how humans live, feel, and perform — physically, mentally, and emotionally.
        </p>
        <div className="belief-intro">
          <p>We believe health innovation should be:</p>
        </div>
        <div className="vision-content">
          <div className="vision-card">
            <svg className="icon-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <circle cx="50" cy="35" r="15" fill="white" opacity="0.9"/>
              <path d="M30,55 Q30,50 35,50 L65,50 Q70,50 70,55 L70,80 Q70,85 65,85 L35,85 Q30,85 30,80 Z" fill="white" opacity="0.9"/>
            </svg>
            <h3>Human-first</h3>
          </div>
          <div className="vision-card">
            <svg className="icon-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              {/* Flask/Beaker for Science */}
              <path d="M35,20 L35,40 L30,70 Q30,80 40,80 L60,80 Q70,80 70,70 L65,40 L65,20 Z"
                    fill="none" stroke="white" strokeWidth="3" opacity="0.9"/>
              <line x1="30" y1="20" x2="70" y2="20" stroke="white" strokeWidth="3" opacity="0.9"/>
              <circle cx="45" cy="60" r="4" fill="white" opacity="0.7"/>
              <circle cx="55" cy="65" r="3" fill="white" opacity="0.7"/>
              <circle cx="50" cy="70" r="3" fill="white" opacity="0.7"/>
            </svg>
            <h3>Science-informed</h3>
          </div>
          <div className="vision-card">
            <svg className="icon-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              {/* Lightbulb for Innovation/Technology */}
              <circle cx="50" cy="40" r="20" fill="white" opacity="0.9"/>
              <path d="M40,58 L40,68 Q40,72 44,72 L56,72 Q60,72 60,68 L60,58"
                    fill="white" opacity="0.9"/>
              <line x1="42" y1="75" x2="58" y2="75" stroke="white" strokeWidth="3" strokeLinecap="round" opacity="0.9"/>
              <line x1="44" y1="80" x2="56" y2="80" stroke="white" strokeWidth="3" strokeLinecap="round" opacity="0.9"/>
              {/* Light rays */}
              <line x1="50" y1="15" x2="50" y2="10" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
              <line x1="70" y1="25" x2="74" y2="21" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
              <line x1="75" y1="40" x2="80" y2="40" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
              <line x1="30" y1="25" x2="26" y2="21" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
              <line x1="25" y1="40" x2="20" y2="40" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
            </svg>
            <h3>Tech-enabled</h3>
          </div>
          <div className="vision-card">
            <svg className="icon-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              {/* Shield for Built to Last/Reliability */}
              <path d="M50,15 L25,25 L25,45 Q25,70 50,85 Q75,70 75,45 L75,25 Z"
                    fill="white" opacity="0.9"/>
              <path d="M50,25 L35,32 L35,48 Q35,65 50,75 Q65,65 65,48 L65,32 Z"
                    fill="rgba(25,118,210,0.5)"/>
              {/* Checkmark */}
              <path d="M42,50 L48,58 L62,40" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <h3>Built to last</h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurVision;
